import { cn } from '@forest/shared'
import * as DialogPrimitives from '@kobalte/core/dialog'
import { Show } from 'solid-js'
import { Spinner } from '~/components/spinner'
import { closeDialog, dialog, setDialogLoading } from '~/store/dialog'

export function Dialog() {
  const handlePrimary = () => {
    if (dialog.asyncPrimaryAction) {
      setDialogLoading(true)
      dialog.asyncPrimaryAction().then(
        () => {
          closeDialog()
        },
        () => {
          closeDialog()
        },
      )
    } else {
      dialog.primaryAction?.()
      closeDialog()
    }
  }

  const handleSecondary = () => {
    dialog.secondaryAction?.()
    closeDialog()
  }

  return (
    <DialogPrimitives.Dialog
      open={dialog.isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen && !dialog.isLoading) closeDialog()
      }}
    >
      <DialogPrimitives.Portal>
        <DialogPrimitives.Overlay class="fixed inset-0 z-50 backdrop-blur-[12.5px] data-[expanded]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[expanded]:fade-in-0" />
        <DialogPrimitives.Content
          class="backdrop-filter-[50px] fixed left-1/2 top-1/2 z-50 w-[calc(100vw-48px)] max-w-[300px] -translate-x-1/2 -translate-y-1/2 rounded-[32px] border-2 border-white/30 bg-white/75 p-6 data-[expanded]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[expanded]:fade-in-0"
          style={{
            'will-change': 'backdrop-filter',
            ['--tw-enter-translate-x' as any]: '-50%',
            ['--tw-enter-translate-y' as any]: '-50%',
            ['--tw-exit-translate-x' as any]: '-50%',
            ['--tw-exit-translate-y' as any]: '-50%',
          }}
          onInteractOutside={(e) => {
            e.preventDefault()
          }}
          onOpenAutoFocus={(e) => {
            e.preventDefault()
          }}
        >
          {/* Content */}
          <div class="flex flex-col gap-6">
            <div class="flex flex-col gap-4">
              <div class="flex flex-col gap-2 text-center">
                <DialogPrimitives.Title class="text-lg font-semibold text-[#333]">
                  {dialog.title}
                </DialogPrimitives.Title>
                <p
                  class={cn(
                    'whitespace-pre-line break-words text-base text-[#666]',
                    dialog.descriptionClass,
                  )}
                >
                  {typeof dialog.description === 'function'
                    ? dialog.description()
                    : dialog.description}
                </p>
              </div>
            </div>

            <Show
              when={dialog.secondaryButtonText}
              fallback={
                <button
                  type="button"
                  class="flex h-[52px] w-full items-center justify-center rounded-xl bg-[#176361] text-base font-bold text-white active:bg-[#0D413F] disabled:bg-[#43807F]"
                  disabled={dialog.isLoading}
                  onClick={handlePrimary}
                >
                  <Show
                    when={!dialog.isLoading}
                    fallback={<Spinner class="size-6 text-[#176361]" />}
                  >
                    {dialog.primaryButtonText}
                  </Show>
                </button>
              }
            >
              <div class="grid grid-cols-2 gap-2">
                <button
                  type="button"
                  class="flex h-[52px] items-center justify-center rounded-xl text-base font-bold text-[#176361]"
                  disabled={dialog.isLoading}
                  onClick={handleSecondary}
                >
                  {dialog.secondaryButtonText}
                </button>
                <button
                  type="button"
                  class="flex h-[52px] items-center justify-center rounded-xl bg-[#176361] text-base font-bold text-white active:bg-[#0D413F] disabled:bg-[#43807F]"
                  disabled={dialog.isLoading}
                  onClick={handlePrimary}
                >
                  <Show
                    when={!dialog.isLoading}
                    fallback={<Spinner class="size-6 text-[#176361]" />}
                  >
                    {dialog.primaryButtonText}
                  </Show>
                </button>
              </div>
            </Show>
          </div>
        </DialogPrimitives.Content>
      </DialogPrimitives.Portal>
    </DialogPrimitives.Dialog>
  )
}
